import { render, staticRenderFns } from "./ExtracaoTabelaFrete.vue?vue&type=template&id=1eb71042"
import script from "./ExtracaoTabelaFrete.vue?vue&type=script&lang=js"
export * from "./ExtracaoTabelaFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports